import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/693a76b5cbbd90001324e6da/phoenix_patio_pro/src/app/faq/components/FAQInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_production/693a76b5cbbd90001324e6da/phoenix_patio_pro/src/components/common/Header.tsx");
